import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ModelCard from '../components/ModelCard';
import './ModelList.css';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

function ModelList() {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clientFilter, setClientFilter] = useState('');
  
  useEffect(() => {
    fetchModels();
  }, [clientFilter]);
  
  async function fetchModels() {
    setLoading(true);
    setError(null);
    
    try {
      const url = new URL(`${API_URL}/api/models`);
      if (clientFilter) url.searchParams.set('client', clientFilter);
      
      const res = await fetch(url);
      if (!res.ok) throw new Error('Failed to fetch models');
      
      const data = await res.json();
      setModels(data.models || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }
  
  async function handleDelete(modelId) {
    if (!confirm('Are you sure you want to delete this model?')) return;
    
    try {
      const res = await fetch(`${API_URL}/api/models/${modelId}`, {
        method: 'DELETE',
      });
      
      if (res.ok) {
        setModels(models.filter(m => m.id !== modelId));
      } else {
        alert('Failed to delete model');
      }
    } catch (err) {
      alert('Error: ' + err.message);
    }
  }
  
  async function handleDownload(modelId, format) {
    try {
      const url = `${API_URL}/api/models/${modelId}/download/${format}`;
      window.open(url, '_blank');
    } catch (err) {
      alert('Error: ' + err.message);
    }
  }
  
  if (loading) {
    return <div className="loading">Loading models...</div>;
  }
  
  if (error) {
    return <div className="error">Error: {error}</div>;
  }
  
  return (
    <div className="model-list-page">
      <div className="page-header">
        <h1>📦 Models</h1>
        <Link to="/upload" className="btn-primary">
          + Upload Model
        </Link>
      </div>
      
      <div className="filters">
        <input
          type="text"
          placeholder="Filter by client..."
          value={clientFilter}
          onChange={(e) => setClientFilter(e.target.value)}
        />
      </div>
      
      {models.length === 0 ? (
        <div className="empty-state">
          <p>No models found.</p>
          <Link to="/upload">Upload your first model</Link>
        </div>
      ) : (
        <div className="models-grid">
          {models.map((model) => (
            <ModelCard
              key={model.id}
              model={model}
              onDelete={() => handleDelete(model.id)}
              onDownload={(format) => handleDownload(model.id, format)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ModelList;

